<template>
    <!-- Popular Providers -->
	<section class="section">
		<div class="container">
			<div class="provider-sec">
				<div class="row justify-content-center">
					<div class="col-lg-12 text-center wow fadeInUp" data-wow-delay="0.2s">
						<div class="section-header text-center">
							<h2 class="mb-1">Popular <span class="text-linear-primary">Providers</span></h2>
							<p class="sub-title">Each listing is designed to be clear and concise, providing customers
							</p>
						</div>
					</div>
				</div>
				<div class="row gx-0">
					<div class="col-xl-3 col-lg-4 col-md-6 d-flex">
						<div class="provider-item flex-fill">
							<div class="d-flex align-items-center">
								<router-link to="/service-provider/provider-details" class="avatar avatar-xl me-2">
									<img src="@/assets/img/profiles/avatar-18.jpg" alt="img" class="rounded-circle">
								</router-link>
								<div>
									<h6><router-link to="/service-provider/provider-details">Hendry Thompson</router-link></h6>
									<p class="fs-14 mb-0"><i class="ti ti-star-filled text-warning me-1"></i>4.4 (123
										Reviews)</p>
									<p class="mb-0">46 Services, From <span class="text-gray-9">$60</span></p>
								</div>
							</div>
						</div>
					</div>
					<div class="col-xl-3 col-lg-4 col-md-6 d-flex">
						<div class="provider-item flex-fill">
							<div class="d-flex align-items-center">
								<router-link to="/service-provider/provider-details" class="avatar avatar-xl me-2">
									<img src="@/assets/img/profiles/avatar-07.jpg" alt="img" class="rounded-circle">
								</router-link>
								<div>
									<h6><router-link to="/service-provider/provider-details">William Patterson</router-link></h6>
									<p class="fs-14 mb-0"><i class="ti ti-star-filled text-warning me-1"></i>4.8 (200
										Reviews)</p>
									<p class="mb-0">40 Services, From <span class="text-gray-9">$70</span></p>
								</div>
							</div>
						</div>
					</div>
					<div class="col-xl-3 col-lg-4 col-md-6 d-flex">
						<div class="provider-item flex-fill">
							<div class="d-flex align-items-center">
								<router-link to="/service-provider/provider-details" class="avatar avatar-xl me-2">
									<img src="@/assets/img/profiles/avatar-08.jpg" alt="img" class="rounded-circle">
								</router-link>
								<div>
									<h6><router-link to="/service-provider/provider-details">Lorenzo Verduzco</router-link></h6>
									<p class="fs-14 mb-0"><i class="ti ti-star-filled text-warning me-1"></i>4.6 (270
										Reviews)</p>
									<p class="mb-0">52 Services, From <span class="text-gray-9">$55</span></p>
								</div>
							</div>
						</div>
					</div>
					<div class="col-xl-3 col-lg-4 col-md-6 d-flex">
						<div class="provider-item flex-fill">
							<div class="d-flex align-items-center">
								<router-link to="/service-provider/provider-details" class="avatar avatar-xl me-2">
									<img src="@/assets/img/profiles/avatar-09.jpg" alt="img" class="rounded-circle">
								</router-link>
								<div>
									<h6><router-link to="/service-provider/provider-details">Rafael Smith</router-link></h6>
									<p class="fs-14 mb-0"><i class="ti ti-star-filled text-warning me-1"></i>4.8 (300
										Reviews)</p>
									<p class="mb-0">40 Services, From <span class="text-gray-9">$05</span></p>
								</div>
							</div>
						</div>
					</div>
					<div class="col-xl-3 col-lg-4 col-md-6 d-flex">
						<div class="provider-item flex-fill">
							<div class="d-flex align-items-center">
								<router-link to="/service-provider/provider-details" class="avatar avatar-xl me-2">
									<img src="@/assets/img/profiles/avatar-08.jpg" alt="img" class="rounded-circle">
								</router-link>
								<div>
									<h6><router-link to="/service-provider/provider-details">Robert Boyd</router-link></h6>
									<p class="fs-14 mb-0"><i class="ti ti-star-filled text-warning me-1"></i>4.8 (300
										Reviews)</p>
									<p class="mb-0">40 Services, From <span class="text-gray-9">$70</span></p>
								</div>
							</div>
						</div>
					</div>
					<div class="col-xl-3 col-lg-4 col-md-6 d-flex">
						<div class="provider-item flex-fill">
							<div class="d-flex align-items-center">
								<router-link to="/service-provider/provider-details" class="avatar avatar-xl me-2">
									<img src="@/assets/img/profiles/avatar-19.jpg" alt="img" class="rounded-circle">
								</router-link>
								<div>
									<h6><router-link to="/service-provider/provider-details">Joe Fletcher</router-link></h6>
									<p class="fs-14 mb-0"><i class="ti ti-star-filled text-warning me-1"></i>4.9 (370
										Reviews)</p>
									<p class="mb-0">65 Services, From <span class="text-gray-9">$50</span></p>
								</div>
							</div>
						</div>
					</div>
					<div class="col-xl-3 col-lg-4 col-md-6 d-flex">
						<div class="provider-item flex-fill">
							<div class="d-flex align-items-center">
								<router-link to="/service-provider/provider-details" class="avatar avatar-xl me-2">
									<img src="@/assets/img/profiles/avatar-11.jpg" alt="img" class="rounded-circle">
								</router-link>
								<div>
									<h6><router-link to="/service-provider/provider-details">Benjamin Wade</router-link></h6>
									<p class="fs-14 mb-0"><i class="ti ti-star-filled text-warning me-1"></i>4.2 (220
										Reviews)</p>
									<p class="mb-0">30 Services, From <span class="text-gray-9">$40</span></p>
								</div>
							</div>
						</div>
					</div>
					<div class="col-xl-3 col-lg-4 col-md-6 d-flex">
						<div class="provider-item flex-fill">
							<div class="d-flex align-items-center">
								<router-link to="/service-provider/provider-details" class="avatar avatar-xl me-2">
									<img src="@/assets/img/profiles/avatar-12.jpg" alt="img" class="rounded-circle">
								</router-link>
								<div>
									<h6><router-link to="/service-provider/provider-details">William Hughes</router-link></h6>
									<p class="fs-14 mb-0"><i class="ti ti-star-filled text-warning me-1"></i>4.3 (280
										Reviews)</p>
									<p class="mb-0">35 Services, From <span class="text-gray-9">$45</span></p>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="text-center view-all wow fadeInUp" data-wow-delay="0.2s">
					<router-link to="/service-provider/providers" class="btn btn-dark">View All<i class="ti ti-arrow-right ms-2"></i></router-link>
				</div>
			</div>
		</div>
	</section>
	<!-- /Popular Providers -->
     
	<!-- Service Section -->
	<section class="section rated-section">
		<div class="container">
			<div class="row justify-content-center">
				<div class="col-lg-6 text-center wow fadeInUp" data-wow-delay="0.2s">
					<div class="section-header text-center mb-4">
						<h2 class="mb-1">Browse <span class="text-linear-primary">High Rated Services</span></h2>
						<p class="sub-title">Each listing is designed to be clear and concise, providing customers</p>
					</div>
				</div>
			</div>
			<ul class="nav nav-tabs nav-tabs-solid justify-content-center mb-4">
				<li class="nav-item mb-3"><a class="nav-link" href="#rate-removals" data-bs-toggle="tab">Removals</a>
				</li>
				<li class="nav-item mb-3"><a class="nav-link" href="#rate-furniture" data-bs-toggle="tab">Furniture
						Assembly</a></li>
				<li class="nav-item mb-3"><a class="nav-link active" href="#rate-electrical"
						data-bs-toggle="tab">Electrical Services</a></li>
				<li class="nav-item mb-3"><a class="nav-link" href="#rate-construction"
						data-bs-toggle="tab">Construction</a></li>
				<li class="nav-item mb-3"><a class="nav-link" href="#rate-man" data-bs-toggle="tab">Man & Van</a></li>
				<li class="nav-item mb-3"><a class="nav-link" href="#rate-plumbing" data-bs-toggle="tab">Plumbing</a>
				</li>
				<li class="nav-item mb-3"><a class="nav-link" href="#rate-more" data-bs-toggle="tab">More Services</a>
				</li>
			</ul>
			<div class="tab-content">
				<div class="tab-pane fade" id="rate-removals">
					<div class="row g-4">
						<div class="col-md-6 col-lg-3">
							<router-link to="/details/service-details" class="rated-wrap">
								<img src="@/assets/img/services/rated-service-05.jpg" alt="img" class="img-fluid">
								<h6 class="text-white">Laser Tattoo Removal</h6>
							</router-link>
						</div>
						<div class="col-md-6 col-lg-3">
							<router-link to="/details/service-details" class="rated-wrap">
								<img src="@/assets/img/services/rated-service-06.jpg" alt="img" class="img-fluid">
								<h6 class="text-white">Surgical Excision</h6>
							</router-link>
						</div>
						<div class="col-md-6 col-lg-3">
							<router-link to="/details/service-details" class="rated-wrap">
								<img src="@/assets/img/services/rated-service-07.jpg" alt="img" class="img-fluid">
								<h6 class="text-white">Saline Tattoo Removal</h6>
							</router-link>
						</div>
						<div class="col-md-6 col-lg-3">
							<router-link to="/details/service-details" class="rated-wrap">
								<img src="@/assets/img/services/rated-service-08.jpg" alt="img" class="img-fluid">
								<h6 class="text-white">Tattoo Removal Creams</h6>
							</router-link>
						</div>
					</div>
				</div>
				<div class="tab-pane fade" id="rate-furniture">
					<div class="row g-4">
						<div class="col-md-6 col-lg-3">
							<router-link to="/details/service-details" class="rated-wrap">
								<img src="@/assets/img/services/rated-service-09.jpg" alt="img" class="img-fluid">
								<h6 class="text-white">Home Furniture Assembly</h6>
							</router-link>
						</div>
						<div class="col-md-6 col-lg-3">
							<router-link to="/details/service-details" class="rated-wrap">
								<img src="@/assets/img/services/rated-service-10.jpg" alt="img" class="img-fluid">
								<h6 class="text-white">Office Furniture Assembly</h6>
							</router-link>
						</div>
						<div class="col-md-6 col-lg-3">
							<router-link to="/details/service-details" class="rated-wrap">
								<img src="@/assets/img/services/rated-service-11.jpg" alt="img" class="img-fluid">
								<h6 class="text-white">Fitness Equipment Assembly</h6>
							</router-link>
						</div>
						<div class="col-md-6 col-lg-3">
							<router-link to="/details/service-details" class="rated-wrap">
								<img src="@/assets/img/services/rated-service-12.jpg" alt="img" class="img-fluid">
								<h6 class="text-white">Shelving & Storage Assembly</h6>
							</router-link>
						</div>
					</div>
				</div>
				<div class="tab-pane fade show active" id="rate-electrical">
					<div class="row g-4">
						<div class="col-md-6 col-lg-3 wow fadeInUp" data-wow-delay="0.2s">
							<router-link to="/details/service-details" class="rated-wrap">
								<img src="@/assets/img/services/rated-service-01.jpg" alt="img" class="img-fluid">
								<h6 class="text-white">Wiring and rewiring</h6>
							</router-link>
						</div>
						<div class="col-md-6 col-lg-3 wow fadeInUp" data-wow-delay="0.4s">
							<router-link to="/details/service-details" class="rated-wrap">
								<img src="@/assets/img/services/rated-service-02.jpg" alt="img" class="img-fluid">
								<h6 class="text-white">Ceiling fan installation</h6>
							</router-link>
						</div>
						<div class="col-md-6 col-lg-3 wow fadeInUp" data-wow-delay="0.6s">
							<router-link to="/details/service-details" class="rated-wrap">
								<img src="@/assets/img/services/rated-service-03.jpg" alt="img" class="img-fluid">
								<h6 class="text-white">Faulty wiring repair</h6>
							</router-link>
						</div>
						<div class="col-md-6 col-lg-3 wow fadeInUp" data-wow-delay="0.8s">
							<router-link to="/details/service-details" class="rated-wrap">
								<img src="@/assets/img/services/rated-service-04.jpg" alt="img" class="img-fluid">
								<h6 class="text-white">Light fixture repair</h6>
							</router-link>
						</div>
					</div>
				</div>
				<div class="tab-pane fade" id="rate-construction">
					<div class="row g-4">
						<div class="col-md-6 col-lg-3">
							<router-link to="/details/service-details" class="rated-wrap">
								<img src="@/assets/img/services/rated-service-13.jpg" alt="img" class="img-fluid">
								<h6 class="text-white">Residential Construction</h6>
							</router-link>
						</div>
						<div class="col-md-6 col-lg-3">
							<router-link to="/details/service-details" class="rated-wrap">
								<img src="@/assets/img/services/rated-service-14.jpg" alt="img" class="img-fluid">
								<h6 class="text-white">Roofing Services</h6>
							</router-link>
						</div>
						<div class="col-md-6 col-lg-3">
							<router-link to="/details/service-details" class="rated-wrap">
								<img src="@/assets/img/services/rated-service-15.jpg" alt="img" class="img-fluid">
								<h6 class="text-white">Commercial Construction</h6>
							</router-link>
						</div>
						<div class="col-md-6 col-lg-3">
							<router-link to="/details/service-details" class="rated-wrap">
								<img src="@/assets/img/services/rated-service-16.jpg" alt="img" class="img-fluid">
								<h6 class="text-white">Site Preparation</h6>
							</router-link>
						</div>
					</div>
				</div>
				<div class="tab-pane fade" id="rate-man">
					<div class="row g-4">
						<div class="col-md-6 col-lg-3">
							<router-link to="/details/service-details" class="rated-wrap">
								<img src="@/assets/img/services/rated-service-17.jpg" alt="img" class="img-fluid">
								<h6 class="text-white">Local Moves</h6>
							</router-link>
						</div>
						<div class="col-md-6 col-lg-3">
							<router-link to="/details/service-details" class="rated-wrap">
								<img src="@/assets/img/services/rated-service-18.jpg" alt="img" class="img-fluid">
								<h6 class="text-white">Furniture Delivery</h6>
							</router-link>
						</div>
						<div class="col-md-6 col-lg-3">
							<router-link to="/details/service-details" class="rated-wrap">
								<img src="@/assets/img/services/rated-service-19.jpg" alt="img" class="img-fluid">
								<h6 class="text-white">House Clearance</h6>
							</router-link>
						</div>
						<div class="col-md-6 col-lg-3">
							<router-link to="/details/service-details" class="rated-wrap">
								<img src="@/assets/img/services/rated-service-20.jpg" alt="img" class="img-fluid">
								<h6 class="text-white">Urgent Deliveries</h6>
							</router-link>
						</div>
					</div>
				</div>
				<div class="tab-pane fade" id="rate-plumbing">
					<div class="row g-4">
						<div class="col-md-6 col-lg-3">
							<router-link to="/details/service-details" class="rated-wrap">
								<img src="@/assets/img/services/rated-service-21.jpg" alt="img" class="img-fluid">
								<h6 class="text-white">Water Filtration</h6>
							</router-link>
						</div>
						<div class="col-md-6 col-lg-3">
							<router-link to="/details/service-details" class="rated-wrap">
								<img src="@/assets/img/services/rated-service-22.jpg" alt="img" class="img-fluid">
								<h6 class="text-white">Emergency Plumbing Repairs</h6>
							</router-link>
						</div>
						<div class="col-md-6 col-lg-3">
							<router-link to="/details/service-details" class="rated-wrap">
								<img src="@/assets/img/services/rated-service-23.jpg" alt="img" class="img-fluid">
								<h6 class="text-white">Drain Cleaning</h6>
							</router-link>
						</div>
						<div class="col-md-6 col-lg-3">
							<router-link to="/details/service-details" class="rated-wrap">
								<img src="@/assets/img/services/rated-service-24.jpg" alt="img" class="img-fluid">
								<h6 class="text-white">Pipe Installation & Repair</h6>
							</router-link>
						</div>
					</div>
				</div>
				<div class="tab-pane fade" id="rate-more">
					<div class="row g-4">
						<div class="col-md-6 col-lg-3">
							<router-link to="/details/service-details" class="rated-wrap">
								<img src="@/assets/img/services/rated-service-11.jpg" alt="img" class="img-fluid">
								<h6 class="text-white">Fitness Equipment Assembly</h6>
							</router-link>
						</div>
						<div class="col-md-6 col-lg-3">
							<router-link to="/details/service-details" class="rated-wrap">
								<img src="@/assets/img/services/rated-service-03.jpg" alt="img" class="img-fluid">
								<h6 class="text-white">Faulty wiring repair</h6>
							</router-link>
						</div>
						<div class="col-md-6 col-lg-3">
							<router-link to="/details/service-details" class="rated-wrap">
								<img src="@/assets/img/services/rated-service-15.jpg" alt="img" class="img-fluid">
								<h6 class="text-white">Commercial Construction</h6>
							</router-link>
						</div>
						<div class="col-md-6 col-lg-3">
							<router-link to="/details/service-details" class="rated-wrap">
								<img src="@/assets/img/services/rated-service-19.jpg" alt="img" class="img-fluid">
								<h6 class="text-white">House Clearance</h6>
							</router-link>
						</div>
					</div>
				</div>
			</div>
			<div class="text-center view-all wow fadeInUp" data-wow-delay="0.2s">
				<router-link to="/service/services-grid" class="btn btn-dark">View All<i class="ti ti-arrow-right ms-2"></i></router-link>
			</div>
		</div>
	</section>
    <!-- /Service Section -->
</template>